export default {
  history: {
    spacecraft: {},
    modular_object: {},
  },
};
